var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "form" },
    [
      _c(
        "v-layout",
        { staticClass: "procedure-container", attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", md2: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { disabled: !_vm.showTooltip, top: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      slot: "activator",
                      "error-messages": _vm.minutesErrors,
                      type: "number",
                      label: "Minutes",
                      placeholder: "# Mins",
                      required: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.v.$each[_vm.index].minutes.$touch()
                      },
                      blur: function($event) {
                        return _vm.v.$each[_vm.index].minutes.$touch()
                      },
                      change: _vm.calculateMinutes
                    },
                    slot: "activator",
                    model: {
                      value: _vm.record.minutes,
                      callback: function($$v) {
                        _vm.$set(_vm.record, "minutes", $$v)
                      },
                      expression: "record.minutes"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enter # of minutes for procedure")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md9: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { disabled: !_vm.showTooltip, top: "" } },
                [
                  _c("v-combobox", {
                    attrs: {
                      slot: "activator",
                      items: _vm.medicaidArray,
                      label: "Procedure Description",
                      placeholder: "Enter Procedure Description",
                      "item-text": "procedureName",
                      "error-messages": _vm.procedureErrors,
                      "return-object": true
                    },
                    on: {
                      blur: function($event) {
                        return _vm.v.$each[_vm.index].procedure.$touch()
                      },
                      change: _vm.procedureChanged
                    },
                    slot: "activator",
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(ref) {
                          var item = ref.item
                          var selected = ref.selected
                          return [
                            item.categoryId && item.procedureName
                              ? _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.procedureName) +
                                      "\n            "
                                  )
                                ])
                              : _c("div", [
                                  _c("strong", [_vm._v("Other")]),
                                  _vm._v(
                                    ": " +
                                      _vm._s(_vm.record.procedureName) +
                                      "\n            "
                                  )
                                ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.record.procedure,
                      callback: function($$v) {
                        _vm.$set(_vm.record, "procedure", $$v)
                      },
                      expression: "record.procedure"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Select one or more procedure description(s)")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md1: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "justify-end": "" } },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-top": "20px" },
                          attrs: { slot: "activator", id: "deleteIcon" },
                          on: {
                            click: function($event) {
                              return _vm.emitRemoveRecordClicked(_vm.index)
                            }
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n            mdi-delete\n          ")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Delete procedure")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c8f6cd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8f6cd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/medicaid-repeatable.vue
// module id = null
// module chunks = 